import axios from "axios";

const BASE = (import.meta.env.VITE_API_URL as string) ?? "";

let _access: string | null = null;

export function setTokens(access: string, refresh: string) {
  _access = access;
  localStorage.setItem("rt", refresh);
}

export function clearTokens() {
  _access = null;
  localStorage.removeItem("rt");
}

export function storedRefreshToken(): string | null {
  return localStorage.getItem("rt");
}

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((cfg) => {
  if (_access) cfg.headers.Authorization = `Bearer ${_access}`;
  return cfg;
});

let refreshing = false;
const queue: Array<(token: string) => void> = [];

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;

    const isAuthEndpoint = (orig.url as string)?.includes("/admin/auth/");
    if (err.response?.status !== 401 || orig._retry || isAuthEndpoint)
      return Promise.reject(err);

    const rt = storedRefreshToken();
    if (!rt) {
      clearTokens();
      window.location.replace("/login");
      return Promise.reject(err);
    }

    if (refreshing) {
      return new Promise((resolve) =>
        queue.push((tok) => {
          orig.headers.Authorization = `Bearer ${tok}`;
          resolve(api(orig));
        })
      );
    }

    orig._retry = true;
    refreshing = true;

    try {
      const { data } = await axios.post<{
        accessToken: string;
        refreshToken: string;
      }>(`${BASE}/admin/auth/refresh`, { refreshToken: rt });
      setTokens(data.accessToken, data.refreshToken);
      queue.splice(0).forEach((cb) => cb(data.accessToken));
      orig.headers.Authorization = `Bearer ${data.accessToken}`;
      return api(orig);
    } catch {
      clearTokens();
      queue.splice(0);
      window.location.replace("/login");
      return Promise.reject(err);
    } finally {
      refreshing = false;
    }
  }
);
